import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { Card, type CardConstructor } from './Card'
import { CardholderFactory } from '../Cardholder'
import { CardStatuses } from '../enums/CardStatusEnum'
import { CardTypes } from '../enums/CardTypeEnum'

export const CardConstructorFactory = Factory.Sync.makeFactory<CardConstructor>(
  {
    id: Factory.each(() => faker.random.number()),
    externalId: Factory.each(() => faker.random.uuid()),
    last4Digits: Factory.each(() => faker.finance.mask(4, false, false)),
    type: CardTypes.VIRTUAL,
    status: CardStatuses.ACTIVE,
    cardholder: Factory.each(() => CardholderFactory.build()),
    createdAt: Factory.each(() => faker.date.past().toISOString()),
    updatedAt: Factory.each(() => faker.date.past().toISOString()),
    requireActivation: false,
  }
)

export const CardFactory = EntityFactory(Card, CardConstructorFactory)
